module.exports = __webpack_public_path__ + "static/media/capa_totem.9d5d0100.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Totem/capa_totem.jpg
// module id = 358
// module chunks = 0